export const iconFontAwesomeCommunicationCommentSms = (
	<i className="fa-solid fa-comment-sms"></i>
);
